import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';

import styles from './Layout.module.css';

const useStyles = makeStyles({
  logo: {
    color: '#f50057',
    fontWeight: 900,
    fontSize: '1.5rem',
    margin: '1em',
    position: 'absolute',
  },
});

export default function Layout({ children }) {
  const classes = useStyles();
  return (
    <div className={styles.container}>
      <Typography className={classes.logo}>Chatty.</Typography>
      <div className={styles.content__container}>
        <div className={styles.content}>{children}</div>
        <footer>
          <Typography style={{ fontSize: '12px' }}>
            Copyright &copy;2020 All rights reserved | Chatty Inc.
          </Typography>
        </footer>
      </div>
      <div className={styles.welcome__container}></div>
    </div>
  );
}
